module.exports = __webpack_public_path__ + "img/Ambivalenz.57b18743.jpg";